import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
// Configurar interceptadores de axios antes de importar a app
import "./utils/axiosConfig";
import App from "./App";

const root = createRoot(document.getElementById("root"));

root.render(<App />);

// If using React version lower than 18:
// ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
